/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IRefinerSortOption } from '@msdyn365-commerce/components';
import { ICustomOrderHistoryResources } from '../custom-order-history.props.autogenerated';
import { SortOption } from './sort-option';

export function mapSortOptionIntoIRefinerSortOption(sortOption: SortOption, resources: ICustomOrderHistoryResources): IRefinerSortOption {
    switch (sortOption) {
        case SortOption.CreatedDateTimeAscending:
            return {
                label: resources.createdDateTimeAscendingSortOptionLabel,
                value: SortOption.CreatedDateTimeAscending
            } as IRefinerSortOption;
        case SortOption.CreatedDateTimeDescending:
            return {
                label: resources.createdDateTimeDescendingSortOptionLabel,
                value: SortOption.CreatedDateTimeDescending
            } as IRefinerSortOption;
        case SortOption.ConfirmedShipDateAscending:
            return {
                label: resources.confirmedShipDateAscendingSortOptionLabel,
                value: SortOption.ConfirmedShipDateAscending
            } as IRefinerSortOption;
        case SortOption.ConfirmedShipDateDescending:
            return {
                label: resources.confirmedShipDateDescendingSortOptionLabel,
                value: SortOption.ConfirmedShipDateDescending
            } as IRefinerSortOption;
        default:
            throw new Error(`Invalid sort option: ${sortOption}`);
    }
}

export function mapIRefinerSortOptionIntoSortOption(refinerSortOption?: IRefinerSortOption): SortOption | undefined {
    if (!refinerSortOption) {
        return;
    }

    if (refinerSortOption.value === SortOption.CreatedDateTimeAscending.toString()) {
        return SortOption.CreatedDateTimeAscending;
    }

    if (refinerSortOption.value === SortOption.CreatedDateTimeDescending.toString()) {
        return SortOption.CreatedDateTimeDescending;
    }

    if (refinerSortOption.value === SortOption.ConfirmedShipDateAscending.toString()) {
        return SortOption.ConfirmedShipDateAscending;
    }

    if (refinerSortOption.value === SortOption.ConfirmedShipDateDescending.toString()) {
        return SortOption.ConfirmedShipDateDescending;
    }

    return;
}
